import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getReferrals = (params) => {
    return axios.get(`${backendHost}/api/admin/referrals/list`, {params});
};

export {
    getReferrals
}